/*  ========================================================================
    # Scripts - Location Selection
    ========================================================================  */

const LocationSelection = {
  cfg: {
    locationCards: document.querySelectorAll('.s-location-selection__location')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.locationCards.forEach(card => {
      const locationTarget = document.getElementById(card.attributes['data-location-target'].value);

      card.addEventListener('mouseenter', () => (locationTarget.style.fill = '#E7680C'));
      card.addEventListener('mouseleave', () => (locationTarget.style.fill = '#000000'));

      if (locationTarget !== null) locationTarget.addEventListener('click', () => card.click());
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.locationCards.length > 0) this.handler();
  }
};

export default LocationSelection;
